import CacheStore from 'services/utils/cacheStore';
import SingletonService from 'services/utils/singletonService';
import http from 'services/utils/http';
import { parseParamsForURL } from 'services/utils/urlParams';
import generalConfig from 'services/metaData/generalConfig';
import TierInstances from './tiers';

const api = 'rate';

class Rate {
    tiers = null;

    cache = CacheStore.getStore(api);

    domain = '';

    constructor() {
        this.domain = generalConfig().sspPlatformJsDomain;
    }

    clearData() {
        this.cache.commit({
            type: 'clearCache',
            api
        });
        TierInstances.clearData();
    }

    getFromCache(filters) {
        return this.cache.getters.getFromCache(api, filters);
    }

    // <editor-fold desc="Get">
    /** *
     *
     * @param refresh
     * @param aniId array of instanceIds
     * @param tagId array of tagIds
     * @param groupId array of groupIds
     * @param countryCode
     * @returns {Promise<null|any>}
     */
    async get({
        refresh, aniId, tagId, groupId, countryCode
    }) {
        const filters = {
            groupId
        };
        if (tagId) {
            filters.tagId = tagId;
        }
        if (aniId) {
            filters.aniId = aniId;
        }
        if (countryCode) {
            filters.countryCode = countryCode;
        }
        if (!refresh) {
            const cachedResult = this.getFromCache(filters);
            if (cachedResult) {
                return cachedResult;
            }
        }

        const params = parseParamsForURL(filters);

        const apiUrl = `${this.domain}/api/v1/partners/rate?${params}`;
        return http.get(apiUrl).then((res) => {
            this.cache.commit({
                type: 'setCache',
                api,
                req: filters,
                data: res
            });
            return res;
        });
    }
    // </editor-fold>

    // <editor-fold desc="Update">
    async update({
        aniId, tagId, groupId, countryCode, rateValue, appKey
    }) {
        const data = {
            groupId,
            rateValue: Math.round(rateValue * 100) / 100 // round up extra decimal points
        };
        if (tagId) {
            data.tagId = tagId;
        }
        if (aniId) {
            data.aniId = aniId;
        }
        if (countryCode) {
            data.countryCode = countryCode;
        }
        const payload = {
            data: [data]
        };
        const filters = {
            appKey
        };
        const params = parseParamsForURL(filters);
        const apiUrl = `${this.domain}/api/v1/partners/rate?${params}`;
        return http.put(apiUrl, payload).then((res) => {
            this.clearData();
            return res;
        });
    }
    // </editor-fold>

    // <editor-fold desc="Delete">
    async deleteLevel({
        aniId, tagId, groupId, countryCode, appKey
    }) {
        const filters = {
            groupId,
            appKey,
            countryCode: countryCode || 0
        };
        if (tagId) {
            filters.tagId = tagId;
        }
        if (aniId) {
            filters.aniId = aniId;
        }

        const params = parseParamsForURL(filters);

        const apiUrl = `${this.domain}/api/v1/partners/rate?${params}`;
        return http.delete(apiUrl).then((res) => {
            this.clearData();
            return res;
        });
    }
    // </editor-fold>
}

const singletonService = new SingletonService(api);
if (!singletonService.isInitialized()) {
    singletonService.setService(new Rate());
}

export default singletonService.getService();
